var $win = $(window);
var $doc = $(document);

$win.on('load', function () {
  try {
    // Label focus move
    $('.field, .textarea, .cf-field > input')
      .on('keydown keyup', function () {
        var $field = $(this),
          $parent = $field.parent(),
          $label = $field.prev('label');

        if ($label.length) {
          $parent.toggleClass('form-show-label', Boolean($field.val().length));
        }
      })
      .each(function () {
        var $field = $(this),
          $parent = $field.parent(),
          $label = $field.prev('label');
        if ($label.length) {
          $parent.toggleClass('form-show-label', Boolean($field.val().length));
        }
      });

    $('.addresses .cancel').on('click', function (event) {
      var $section = $(this).closest('.accordion-section');
      $section.find('.accordion-body').slideUp();
      event.preventDefault();
    });

    $('.btn-new-adress, .form-add-address .cancel').on('click', function (event) {
      $('.form-add-address').slideToggle();
      event.preventDefault();
    });
  } catch (e) {
    Rollbar.error('account js', e);
  }
});
